import React, { createContext, useContext, useMemo } from 'react';

const SensorDataContext = createContext(null);

/**
 * Provides processed sensor data to any component in the dashboard tree.
 * Feed this with outputs from useMultipleBluetooth + useDataProcessing so
 * they are computed once and shared without prop-drilling.
 */
export function SensorDataProvider({ children, value }) {
  return (
    <SensorDataContext.Provider value={value}>
      {children}
    </SensorDataContext.Provider>
  );
}

/**
 * Consume shared sensor data. Returns null when used outside a provider.
 *
 * Shape:
 * {
 *   leftFoot:  { pressure, imu, onPointe, hotspots },
 *   rightFoot: { pressure, imu, onPointe, hotspots },
 *   statistics,          // from useDataProcessing
 *   historicalData,      // { left: [...], right: [...] } for charts
 *   session: { isRecording, timeOnPointe, jumps, turns },
 *   mode,                // 'single' | 'dual'
 *   selectedFoot,        // only relevant in single mode
 * }
 */
export function useSensorData() {
  return useContext(SensorDataContext);
}
